import { Button } from '@/components/common/button'
import { PlusIcon } from '@/components/icons/plus'
import { FilterSelect } from '@/components/shared/filterSelect'
import { useFixedTermMarketsSearchState } from '@/hooks/useFixedTermMarketsSearchState'
import { cn } from '@/utils/cn'
import type { FixedTermMarket } from '@/utils/internalAppSdk'
import type { ReactNode } from 'react'
import { FixedTermMarketsSearchInput } from './fixedTermMarketsSearchInput'
import { useFixedTermMarketsFilterData } from './useFixedTermMarketsFilterData'

interface FixedTermMarketsFiltersProps {
  markets: FixedTermMarket[]
  numberOfMarkets: number
  className?: string
  leadingContent?: ReactNode
}

export const FixedTermMarketsFilters = ({
  markets,
  numberOfMarkets,
  className,
  leadingContent,
}: FixedTermMarketsFiltersProps) => {
  const { assetFilterProps, protocolFilterProps, networkFilterProps } = useFixedTermMarketsFilterData(markets)
  const { activeFiltersCount, clearFilters } = useFixedTermMarketsSearchState()

  return (
    <div className={cn('flex flex-col gap-3', className)}>
      <div className="flex justify-between gap-2">
        {leadingContent}
        <FixedTermMarketsSearchInput
          numberOfMarkets={numberOfMarkets}
          className="flex-grow"
          trackingParams={{ Page: 'Fixed term', Device: 'Desktop' }}
        />
        {activeFiltersCount > 0 && (
          <Button
            variant="input"
            size="md"
            title="Clear filters"
            className="fade-in size-10 animate-in px-0"
            onClick={clearFilters}
          >
            <span className="sr-only">Clear filters</span>
            <PlusIcon size={20} className="rotate-45" />
          </Button>
        )}
      </div>
      <div className="flex flex-wrap gap-2">
        <FilterSelect {...assetFilterProps} />
        <FilterSelect {...protocolFilterProps} />
        <FilterSelect {...networkFilterProps} />
      </div>
    </div>
  )
}
